/* Arfa Electronics — Premium UAE Theme JS */
(function () {
  'use strict';

  var T = window.ArfaTheme || {};

  /* ---------------- Utilities ---------------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var format = 'AED {{amount}}';
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function toast(message, type) {
    var el = document.getElementById('ArfaToast');
    if (!el) return;
    el.textContent = message;
    el.className = 'toast is-visible' + (type ? ' toast--' + type : '');
    clearTimeout(el._t);
    el._t = setTimeout(function () {
      el.className = 'toast';
    }, 2600);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      n.textContent = count;
      n.hidden = count < 1;
    });
  }

  /* ---------------- Mobile menu ---------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var menu = document.getElementById('MobileMenu');
      if (menu) {
        menu.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', menu.classList.contains('is-open'));
      }
    }

    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var sw = document.getElementById('MobileSearch');
      if (sw) sw.classList.toggle('is-open');
    }
  });

  /* ---------------- AJAX add to cart ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var original = button ? button.innerHTML : '';
    if (button) {
      button.disabled = true;
      button.innerHTML = T.strings ? T.strings.adding : 'Adding...';
    }

    fetch(T.cartAddUrl + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Error');
          return data;
        });
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        toast('✅ ' + (T.strings ? T.strings.addedToCart : 'Added to cart!'), 'success');
        if (form.hasAttribute('data-redirect-cart')) {
          window.location.href = T.cartUrl;
        }
      })
      .catch(function (err) {
        toast('⚠️ ' + err.message, 'error');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.innerHTML = original;
        }
      });
  });

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty-wrapper]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'plus' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Cart line item quantity ---------------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line]');
    if (!input) return;
    var line = input.getAttribute('data-cart-line');
    var form = input.closest('form');
    if (form) form.submit();
    void line;
  });

  /* ---------------- Variant picker ---------------- */
  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var sectionId = picker.getAttribute('data-section');
      var dataEl = document.querySelector('[data-product-json="' + sectionId + '"]');
      if (!dataEl) return;
      var product = JSON.parse(dataEl.textContent);

      function onChange() {
        var selected = Array.prototype.map.call(
          picker.querySelectorAll('select[data-option-index], input[data-option-index]:checked'),
          function (el) {
            return el.value;
          }
        );

        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selected[i];
          });
        });

        var idInput = document.querySelector('[data-variant-id="' + sectionId + '"]');
        var priceEl = document.querySelector('[data-variant-price="' + sectionId + '"]');
        var compareEl = document.querySelector('[data-variant-compare="' + sectionId + '"]');
        var submit = document.querySelector('[data-add-button="' + sectionId + '"]');

        if (!variant) {
          if (submit) {
            submit.disabled = true;
            submit.textContent = 'Unavailable';
          }
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (submit) {
          submit.disabled = !variant.available;
          submit.innerHTML = variant.available
            ? '🛒 ' + (T.strings ? T.strings.addToCart : 'Add to Cart')
            : T.strings
            ? T.strings.soldOut
            : 'Sold out';
        }

        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', onChange);
    });
  }

  /* ---------------- Countdown timers ---------------- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var endAttr = el.getAttribute('data-countdown');
      var target;
      if (endAttr && endAttr !== 'midnight') {
        target = new Date(endAttr).getTime();
      } else {
        var d = new Date();
        d.setHours(24, 0, 0, 0);
        target = d.getTime();
      }

      function tick() {
        var diff = Math.max(0, target - Date.now());
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        var map = { days: days, hours: hours, minutes: mins, seconds: secs };
        el.querySelectorAll('[data-unit]').forEach(function (u) {
          var key = u.getAttribute('data-unit');
          u.textContent = String(map[key]).padStart(2, '0');
        });
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (main) main.src = thumb.getAttribute('data-full');
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------------- Accordions ---------------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-accordion-head]');
    if (!head) return;
    var item = head.parentElement;
    item.classList.toggle('is-open');
  });

  /* ---------------- Sticky header shadow ---------------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;
    window.addEventListener(
      'scroll',
      function () {
        header.classList.toggle('is-scrolled', window.scrollY > 20);
      },
      { passive: true }
    );
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    document.querySelectorAll('.reveal').forEach(function (el) {
      obs.observe(el);
    });
  }

  function init() {
    initVariantPickers();
    initCountdowns();
    initGallery();
    initStickyHeader();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();


/* ArfaCart compact mobile proportions 2026-10-15 */
(function(){function apply(){if(document.getElementById('ArfaCartMobilePolish'))return;var s=document.createElement('style');s.id='ArfaCartMobilePolish';s.textContent=`
@media(max-width:749px){
html{scroll-padding-top:64px}body{overflow-x:clip;font-size:14px;line-height:1.5}
.page-width{width:100%;max-width:100%;padding-left:14px!important;padding-right:14px!important}
.section{padding-top:20px!important;padding-bottom:20px!important}.section-head{gap:10px;margin-bottom:12px!important}
.section-head h2,.section-title,.collection-hero__title{font-size:clamp(20px,5.5vw,25px)!important;line-height:1.2}
.header__inner{gap:8px}.header__logo img{max-width:128px;height:auto}
.hero,.hero__content{min-height:0!important;height:auto!important}.hero__content{padding:30px 15px 25px!important;align-items:flex-end}
.hero__title{font-size:clamp(27px,7.5vw,34px)!important;line-height:1.08!important;margin-top:10px!important}
.hero__text{font-size:13px!important;line-height:1.5!important;margin-top:10px!important}
.hero__buttons{margin-top:15px!important;gap:8px!important}.hero__buttons .btn{min-height:40px!important;padding:10px 14px!important}
.hero__points{margin-top:14px!important;gap:7px 12px!important;font-size:10px!important}
.promo,.promo__content{min-height:185px!important}.promo__content{padding:18px!important;max-width:82%!important}
.collection-hero{min-height:0!important;padding:24px 0 20px!important}.collection-hero__content{padding:8px 14px!important}
.collection-hero h1{font-size:clamp(25px,7vw,32px)!important;margin-bottom:8px!important}
.collection-hero__description,.collection-hero__inner>p:not(.section-head__eyebrow){font-size:13px!important;line-height:1.5!important}
.category-page{padding:20px 0 28px!important;min-height:0!important}.category-page__inner{max-width:calc(100% - 28px)!important}
.category-page__head{margin-bottom:12px!important}.category-page__grid{gap:9px!important}
.category-tile{aspect-ratio:1.6/1!important;min-height:0!important;height:auto!important;border-radius:12px!important}
.category-tile__copy{padding:9px!important}.category-tile__title{font-size:12px!important;line-height:1.15!important}
.category-tile__tagline{font-size:9px!important;line-height:1.2!important;margin-top:2px!important}.category-tile__count{display:none!important}
.grid{gap:10px!important}.card__content,.card__info,.product-card__content,.product-card__info{padding:8px!important}
.card__title,.product-card__title{font-size:12px!important;line-height:1.3!important;min-height:0!important}
.card__price,.product-card__price,.price{font-size:13px!important}
.card .btn,.product-card .btn,.product-card button{min-height:36px!important;padding:8px 6px!important;font-size:11px!important}
.product{display:flex;flex-direction:column;gap:16px!important}.gallery__main img{max-height:390px;object-fit:contain!important}
.gallery__thumb{width:58px!important;height:58px!important}.product h1,.product__title{font-size:clamp(23px,6.5vw,29px)!important;line-height:1.15!important}
.product__price{font-size:21px!important}.breadcrumb{font-size:11px;overflow-wrap:anywhere}
.newsletter input,.newsletter button{min-height:42px}
}
@media(max-width:380px){.page-width{padding-left:11px!important;padding-right:11px!important}.grid,.category-page__grid{gap:8px!important}.hero__content{padding-left:12px!important;padding-right:12px!important}}
`;document.head.appendChild(s)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply);else apply();document.addEventListener('shopify:section:load',apply)
  /* Reliable sticky header fallback: pin only after the header reaches viewport top.
     Keeps the original Shopify section height so page content does not jump. */
  function initReliableStickyHeader() {
    var wrap = document.querySelector('.header-wrap');
    if (!wrap || wrap.dataset.reliableStickyReady === 'true') return;
    wrap.dataset.reliableStickyReady = 'true';
    var host = wrap.closest('.shopify-section') || wrap.parentElement;
    var threshold = 0;
    var ticking = false;
    function measure() {
      if (!wrap.classList.contains('arfa-is-fixed')) {
        threshold = wrap.getBoundingClientRect().top + window.pageYOffset;
      }
    }
    function update() {
      ticking = false;
      var shouldFix = window.pageYOffset >= threshold && threshold > 0;
      if (shouldFix && !wrap.classList.contains('arfa-is-fixed')) {
        if (host) host.style.minHeight = wrap.offsetHeight + 'px';
        wrap.classList.add('arfa-is-fixed');
      } else if (!shouldFix && wrap.classList.contains('arfa-is-fixed')) {
        wrap.classList.remove('arfa-is-fixed');
        if (host) host.style.minHeight = '';
        measure();
      }
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
        });
        ticking = true;
      }
    }
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (!wrap.classList.contains('arfa-is-fixed')) measure();
      else if (host) host.style.minHeight = wrap.offsetHeight + 'px';
    });
    window.addEventListener('load', measure, { once: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReliableStickyHeader);
  } else {
    initReliableStickyHeader();
  }
  document.addEventListener('shopify:section:load', initReliableStickyHeader);
})();
